export default {
  banner: {
    addTaxIdTitle: 'Have a {{taxType}}?',
    addTaxIdText: '{{children}} Please add it to the Tax Policies section of your account.',
    buttonText: 'Submit my tax info',
    VAT: 'VAT ID',
    GST: 'GST ID',
  },
};
